import axios from "axios";
import { apiURL } from "./constants";
import { fetchAllPages } from "../utils/pagination";






/**
 * Invoice GET returns nested shipments[] with live billed qty fields:
 * invoice_quantity, invoice_quantity_unit, invoice_quantity_unit_ar, billing_metric.
 * Use those for PDF / detail qty — not raw weight / volumetric_weight.
 */
//get invoice throw api 
export async function readInvoice(invoiceID) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  // get request using axios with error handling
  const response = await axios.get(`${apiURL}/api/invoices/${invoiceID}/`,
    {
      headers:
        { 'Content-Type': 'application/json' },
      withCredentials: true
    }
  )
    .catch((error) => {
      console.error('There was an error!', error);
      throw error;
    });

  return response;
}

//post invoice throw api 
//parameters
//data: the data of the new invoice
export async function postInvoice(data) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  // POST request using axios with error handling
  const response = await axios.post(`${apiURL}/api/invoices/`, data,
    {
      headers:
        { 'Content-Type': 'application/json' },
      withCredentials: true
    }
  )
    .catch((error) => {
      console.error('There was an error!', error);
      throw error;
    });

  return response;
}


//put invoice throw api 
//parameters
//data: the data of the exist invoice
export async function putInvoice(data) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  // POST request using axios with error handling
  const response = await axios.put(`${apiURL}/api/invoices/` + data.id + "/", data,
    {
      headers:
        { 'Content-Type': 'application/json' },
      withCredentials: true
    }
  ).catch((error) => {
    console.error('There was an error!', error);
    throw error;
  });

  return response;
}

/** True when invoice still has payments or is not unpaid — delete is blocked. */
export function isInvoiceDeleteBlocked(invoice) {
  if (!invoice) return true;
  if (invoice.paid === true) return true;
  if (invoice.payment_status !== 'unpaid') return true;
  const payments = invoice.payments;
  if (Array.isArray(payments)) {
    const hasActivePayment = payments.some((p) => p && p.deleted !== true);
    if (hasActivePayment) return true;
  }
  return false;
}

/** Prefer API error / deleted field messages from a failed invoice soft-delete. */
export function getInvoiceDeleteErrorMessage(error, fallback) {
  const data = error && error.response && error.response.data;
  if (!data) return fallback;
  if (typeof data.error === 'string' && data.error) return data.error;
  if (Array.isArray(data.deleted) && data.deleted.length) {
    return data.deleted.filter(Boolean).join(' ');
  }
  if (typeof data.deleted === 'string' && data.deleted) return data.deleted;
  if (typeof data.detail === 'string' && data.detail) return data.detail;
  return fallback;
}

export async function deleteInvoice(invoice) {
  let copiedInvoice = Object.assign({}, invoice);
  const serviceID = copiedInvoice.id;
  copiedInvoice["deleted"] = true;
  copiedInvoice["customer"] = copiedInvoice.customer.id;
  copiedInvoice["shipments"] = copiedInvoice["shipments"].map(shipment => shipment.id);

  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  const response = axios.put(`${apiURL}/api/invoices/` + serviceID + "/", copiedInvoice,
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true
    }
  ).catch((error) => {
    console.error('There was an error!', error);
    throw error;
  });
  return response;
}





//Get customer shipments for new invoice
export async function readShipments(user) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;

  const allResults = await fetchAllPages(async (page, pageSize) => {
    const response = await axios.get(`${apiURL}/gofar/shipment/`, {
      params: {
        owner__id: user.id,
        invoiced: false,
        page,
        page_size: pageSize,
      },
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }).catch((error) => {
      console.error('There was an error!', error);
      throw error;
    });
    return response;
  }, { pageSize: 50 });

  return {
    data: allResults,
  };
}

export async function createInvoices(send_invoices_messages) {

  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  // POST request using axios with error handling
  const response = await axios.post(`${apiURL}/api/create-invoices/?send_invoices_messages=${send_invoices_messages}`,
    {
      headers:
        { 'Content-Type': 'application/json' },
      withCredentials: true
    }
  )
    .catch((error) => {
      console.error('There was an error!', error);
      throw error;
    });

  return response;

}

export async function regenerateInvoicesRequest(invoices_ids, send_invoices_messages) {

  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  // POST request using axios with error handling
  const response = await axios.post(`${apiURL}/api/regenerate-invoices/?send_invoices_messages=${send_invoices_messages}`,
    {"invoices_ids" : invoices_ids},
    {
      headers:
        { 'Content-Type': 'application/json' },
      withCredentials: true
    }
  )
    .catch((error) => {
      console.error('There was an error!', error);
      throw error;
    });

  return response;

}

export async function updateInvoicesPaymentStatusRequest(invoices_ids) {

  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  // POST request using axios with error handling
  const response = await axios.put(`${apiURL}/api/update_invoices_payment_status/`,
    {"invoices_ids" : invoices_ids},
    {
      headers:
        { 'Content-Type': 'application/json' },
      withCredentials: true
    }
  )
    .catch((error) => {
      console.error('There was an error!', error);
      throw error;
    });

  return response;

}
export async function generateInvoicesForShipmentsRequest(shipments_ids, send_invoices_messages) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  // POST request using axios with error handling
  const response = await axios.post(`${apiURL}/api/generate_invoices_for_shipments/?send_invoices_messages=${send_invoices_messages}`,
    {"shipments_ids": shipments_ids},
    {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    }
  )
    .catch((error) => {
      console.error('There was an error!', error);
      throw error;
    });

  return response;
}

/** GET /api/invoices/{id}/checkouts/ — list InvoiceCheckout rows for staff. */
export async function listInvoiceCheckouts(invoiceId) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  const response = await axios.get(`${apiURL}/api/invoices/${invoiceId}/checkouts/`, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  }).catch((error) => {
    console.error('There was an error!', error);
    throw error;
  });
  return response;
}

/**
 * POST /api/invoices/{id}/checkouts/
 * Body: { amount: string, note?: string }
 */
export async function createInvoiceCheckout(invoiceId, { amount, note } = {}) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  const body = { amount: String(amount) };
  if (note != null && String(note).trim() !== '') {
    body.note = String(note).trim();
  }
  const response = await axios.post(
    `${apiURL}/api/invoices/${invoiceId}/checkouts/`,
    body,
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  ).catch((error) => {
    console.error('There was an error!', error);
    throw error;
  });
  return response;
}

/** POST /api/invoices/{id}/checkouts/{checkoutId}/cancel/ — cancel a pending checkout. */
export async function cancelInvoiceCheckout(invoiceId, checkoutId) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  const response = await axios.post(
    `${apiURL}/api/invoices/${invoiceId}/checkouts/${checkoutId}/cancel/`,
    {},
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  ).catch((error) => {
    console.error('There was an error!', error);
    throw error;
  });
  return response;
}

/**
 * POST /api/invoices/{id}/pay-full/
 * Cancels all pending checkouts and creates one for amount_due.
 */
export async function payFullInvoice(invoiceId) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  const response = await axios.post(
    `${apiURL}/api/invoices/${invoiceId}/pay-full/`,
    {},
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  ).catch((error) => {
    console.error('There was an error!', error);
    throw error;
  });
  return response;
}

/** POST /api/invoices/{id}/whatsapp-checkout/ — set which checkout link is sent in WhatsApp. */
export async function setInvoiceWhatsAppCheckout(invoiceId, checkoutId) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  const response = await axios.post(
    `${apiURL}/api/invoices/${invoiceId}/whatsapp-checkout/`,
    { checkout_id: checkoutId },
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  ).catch((error) => {
    console.error('There was an error!', error);
    throw error;
  });
  return response;
}

// Bulk send WhatsApp invoice notifications for selected invoice ids.
export async function bulkSendInvoicesWhatsappMessage(invoice_ids) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  const response = await axios.post(`${apiURL}/api/bulk_send_invoices_whatsapp_message/`,
    { invoice_ids },
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  ).catch((error) => {
    console.error('There was an error!', error);
    throw error;
  });

  return response;
}
